import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';
import { EMPLOYEE_STATUS } from '../../employees/actions/load-org-employees-by-status';
import { setOrgEmployeesDirty } from '../../employees/actions/set-org-employees-dirty';

import { del } from '../../api/api';

export const deleteMergeIntegration = (orgId: number) =>
  createGenericDispatcher({
    name: 'DELETE_MERGE_INTEGRATION',
    loadFunction: () => del(`/merge?orgId=${orgId}`),
    args: { orgId },
    onSuccess: (dispatch) => {
      dispatch(
        addNotificationAction({
          key: `delete-merge-integration-${orgId}`,
          message: 'Integration successfully deleted',
        }),
      );
      dispatch(setOrgEmployeesDirty(orgId, EMPLOYEE_STATUS.CURRENT));
      dispatch(setOrgEmployeesDirty(orgId, EMPLOYEE_STATUS.FORMER));
    },
  });
